import { cart } from 'core';
import { Balance } from 'ui/components';

export const CartBalance = () => {
  const {
    data: { total, totalProfit },
  } = cart.hooks.useCart();

  return <Balance profit={totalProfit} total={total} />;
};
